// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container{width:100%;height:100%;position:relative}.table-container .scroll-container{height:100%}.table-container table{min-width:100%;overflow:auto;max-height:100%;border-spacing:0 0;table-layout:fixed}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
